exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-row {\n  margin-bottom: 20px;\n&:last-child {\n    margin-bottom: 0;\n}\nimg {\n    width: 90%;\n}\n}\n.el-col {\n  border-radius: 4px;\n}\n.bg-purple-dark {\n  background: #99a9bf;\n}\n.bg-purple {\n  background: #d3dce6;\n}\n.bg-purple-light {\n  background: #e5e9f2;\n}\n.grid-content {\n  border-radius: 4px;\n  min-height: 10px;\nimg {\n    width: 90%;\n}\n}\n.row-bg {\n  padding: 10px 20px;\n  background-color: #f9fafc;\n}\n.service-label .el-checkbox:first-child{\n  margin-left: 15px;\n}\n.service-label .el-input:first-child{\n  margin-left: 15px;\n}\n.grid-detail {\n  max-height: 300px;\n  overflow-y: scroll;\n  margin-bottom: 20px;\n}\n.el-carousel {\n  width: 375px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-61c151be","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/base/setting/companys/logs.vue
// module id = 1532
// module chunks = 0